<template>
<div>
<b-popover :target="targetId" triggers="click blur" placement="top">
    <h3 class="popover-header">{{$t('shareInSocialMedia')}}
    </h3>
    <div class="popover-article">
        <ShareNetwork
        v-for="socialNetwork in socialNetworks.networks"
        :network="socialNetwork.network"
        :key="socialNetwork.network"
        :style="{'background-Color': socialNetwork.color}"
        :url="url"
        :title="socialNetworks.sharing.title"
        :description="socialNetworks.sharing.description"
        :quote="socialNetworks.sharing.quote"
        :hashtags="socialNetworks.sharing.hashtags"
        :twitterUser="socialNetworks.sharing.twitterUser"
        >
        <b-icon font-scale="1.5" :icon="socialNetwork.icon"></b-icon>
        <span>{{ socialNetwork.name }}</span>
        </ShareNetwork>
        <a class="share-network-link" @click="copyLinkClipboard(url)" style="background-color: #4a76a8;"><b-icon font-scale="1.5" icon="share"></b-icon><span>{{$t('link')}}</span></a>
    </div>
</b-popover>
</div>
</template>

<script>
import { BPopover } from 'bootstrap-vue'
import { ShareNetwork } from 'vue-social-sharing'

export default {
    name: 'socialSharingPopover',
    components: {
        BPopover,
        ShareNetwork
    },
    props: {
      sectionName: String,
      socialNetworks: {
        type: Object,
        default () {
            return {
                sharing: {
                  url: '',
                  title: this.$t('sharingSocialsTitle', [this.sectionName]),
                  description: this.$t('sharingSocialsDescription'),
                  quote: '',
                  hashtags: 'opensalud',
                  twitterUser: ''
                },
                networks: [
                  { network: 'email', name: 'Email', icon: 'envelope', color: '#333333' },
                  { network: 'twitter', name: 'Twitter', icon: 'twitter', color: '#1da1f2' },
                  { network: 'facebook', name: 'Facebook', icon: 'facebook', color: '#1877f2' },
                  { network: 'whatsapp', name: 'Whatsapp', icon: 'whatsapp', color: '#25d366' },
                  { network: 'linkedin', name: 'LinkedIn', icon: 'linkedin', color: '#007bb5' },
                  { network: 'telegram', name: 'Telegram', icon: 'telegram', color: '#0088cc' }
                ]
            }
        }
      },
      url: String,
      targetId: String
    },
    data () {
        return {
        }
    },
    created () {
        document.getElementsByTagName('body')[0].addEventListener('click', e => {
            this.$root.$emit('bv::hide::popover')
        })
    },
    methods: {
      copyLinkClipboard (url) {
        navigator.clipboard.writeText(url)
        this.$store.dispatch('showSuccessAlert', this.$t('linkCopiedClipboard'))
      }
    }
}
</script>

<style lang="scss">
.share-network-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}
a[class^="share-network-"] {
  flex: none;
  color: #FFFFFF;
  background-color: #333;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 10px 10px 0;
  padding: 1%;
}
// a[class^="share-network-"] .bi {
//   background-color: rgba(0, 0, 0, 0.2);
//   padding: 10px;
//   flex: 0 1 auto;
// }
a[class^="share-network-"] span {
  padding: 0 10px;
  flex: 1 1 0%;
  font-weight: 500;
}
.popover{
  max-width: initial !important;
}
.popover-article{
  display: flex;
  width: 751px;
  @include media(mobile) {
    flex-direction: column;
    width: initial;
  }
}
.popover-header{
  text-align: center;
  background-color: initial;
  border-bottom: initial;
}
</style>


// WEBPACK FOOTER //
// src/components/base/ui/SocialSharingPopover.vue